import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';

import * as visaLogo from './static/img/visa.svg';
import * as mastercardLogo from './static/img/mastercard.svg';

import './index.scss';

interface Props {}

type Enhanced = Props & InjectedTranslateProps;

const enhance = compose<Enhanced, Props>(translate);

const b = b_.with('footer-info');

const Info: React.FC<Enhanced> = ({ t, language }) => {
  const lang = language.toLowerCase();

  const policyLink = `https://investment-s3.unitedtraders.io/files/privacy-policy_${lang}.pdf`;

  const riskStatementsLink =
    'https://investment-s3.unitedtraders.io/files/Risk_Statement_UT_Overseas_170918.pdf';

  return (
    <div className={b()}>
      <div className={b('logos')}>
        <img src={visaLogo} alt="Visa" />
        <img src={mastercardLogo} alt="Mastercard" />
      </div>
      <div className={b('links')}>
        <a href={riskStatementsLink} target="_blank" rel="noopener" className={b('link')}>
          {t('Risk statements')}
        </a>
        <a className={b('link')} href={policyLink} target="_blank" rel="noopener">
          {t('Privacy policy')}
        </a>
      </div>
    </div>
  );
};

export default enhance(Info);
